import * as qplsService from '../../../services/Qpls/qplsService'
import {gridsNames} from '../../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    return qplsService.fetchQpls(query);
  }
}

function _convertToRowData(data) {

  const flattenedData = [];

  data?.forEach(parentNode => { // flatten data to conform to ag-grid's tree data structure.
    parentNode.hierarchy = [parentNode.id];
    parentNode.isParent = true;

    flattenedData.push(parentNode);
    parentNode?.allVersions?.forEach(childNode => {
      childNode.hierarchy = [parentNode.id, childNode.id];
      flattenedData.push(childNode);
    });
  });
  return flattenedData;

}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
